import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { Icon } from '~/components/Icon';
import { cn } from '~/lib/cn';
import { FlexCol } from '~/modules/artist-roster/components/flex/FlexCol';
import { FlexRow } from '~/modules/artist-roster/components/flex/FlexRow';
import { MusicIqIcon } from '~/modules/music-iq/pages/chatbot-page/components/MusicIqIcon';

import type { ChatMessage } from '../types';

interface MessageProps {
  message: ChatMessage;
}

export function Message({ message }: MessageProps) {
  if (!message.content) {
    return null;
  }

  if (message.type === 'user') {
    return (
      <FlexRow className="w-full justify-end text-body-sm leading-5">
        <div className="max-w-[80%] rounded-sm p-md bg-primary-default">
          <p className="whitespace-pre-wrap text-body-sm">{message.content}</p>
        </div>
      </FlexRow>
    );
  }

  if (message.type === 'error') {
    return (
      <FlexRow className="w-full items-center gap-sm py-sm text-body-sm leading-5 text-error-default">
        <Icon type="exclamation-circle" size="md" />
        <span
          className="whitespace-pre-wrap text-body-sm leading-none"
          role="alert"
        >
          {message.content}
        </span>
      </FlexRow>
    );
  }

  return (
    <div className="flex w-full justify-start text-body-sm leading-5">
      <FlexCol className="w-full">
        <MusicIqIcon className="mb-sm mt-md h-[22px] w-[22px]" />
        <div className={cn('max-w-[80%] overflow-y-auto')}>
          {message.type === 'aborted' ? (
            <span className="italic">{message.content}</span>
          ) : (
            <div className="prose prose-sm prose-invert max-w-none">
              <Markdown remarkPlugins={[remarkGfm]}>{message.content}</Markdown>
            </div>
          )}
        </div>
      </FlexCol>
    </div>
  );
}

Message.displayName = 'Message';
